import { css } from 'lit';

export default css`
  .audio {
    display: none;
  }

  .audio__wrapper {
    width: 200px;
    height: 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 8px 12px 8px 12px;
    border: 1px solid var(--amityeko-color-gray-8);
    border-radius: var(--amityeko-radius-small);
    background-color: var(--private-audio-bg-color);
  }

  .button {
    border: 0;
    box-sizing: border-box;
    background: transparent;
    width: 0;
    border-color: transparent transparent transparent var(--private-play-btn-color);
    transition: 100ms all ease;
    cursor: pointer;
    /** play state */
    border-style: solid;
    border-width: 10px 0px 10px 15px;
  }

  .button--pause {
    height: 15px;
    border-style: double;
    border-width: 0 0 0 15px;
  }

  .timeline__wrapper {
    flex-basis: 80%;
  }

  .timeline {
    width: 100%;
    height: 2px;
    background-color: var(--private-timeline-color);
  }

  .bar {
    background: rgba(120, 120, 128, 0.32);
    border-radius: var(--amityeko-radius-medium);
    height: 2px;
    flex: 1;
    display: flex;
  }

  .inner {
    background: black;
    width: 0%;
    height: 100%;
  }

  .progress__circle {
    width: 15px;
    height: 15px;
    background-color: #ffffff;
    border-radius: 50%;
    margin-top: -7px;
    box-shadow: 0px 0px 2px rgba(40, 41, 61, 0.04), 0px 4px 8px rgba(96, 97, 112, 0.12);
  }

  amityeko-tg-caption {
    color: var(--private-remaining-time-color);
  }
  amityeko-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
